/* eslint-disable inclusive-language/use-inclusive-words */
import { TagFilled } from '@ant-design/icons';
import React from 'react';

import { Permissions } from '../../apis/graphql/types';
import { ReactComponent as AmericanExpress } from '../../assets/images/americanExpressLogo.svg';
import { ReactComponent as Billing } from '../../assets/images/billing.svg';
import { ReactComponent as Discover } from '../../assets/images/discoverLogo.svg';
import { ReactComponent as MasterCard } from '../../assets/images/masterCardLogo.svg';
import { ReactComponent as PaymentMethods } from '../../assets/images/payment.svg';
import { ReactComponent as ProfileIcon } from '../../assets/images/profile.svg';
import { ReactComponent as Notifications } from '../../assets/images/thunderclap.svg';
import { ReactComponent as UsersIcon } from '../../assets/images/user.svg';
import { ReactComponent as Visa } from '../../assets/images/visaLogo.svg';
import { Tab, TAB_ITEMS_KEYS } from '../../components/SideMenu/types';

export const MENU_ROUTES = {
  profile: '/profile',
  users: '/users',
  brands: '/brands',
  paymentMethods: '/paymentMethods',
  billing: '/billing',
  notifications: '/notifications',
};

export const getMenuItems = (permissions: Permissions): Tab[] => [
  {
    title: TAB_ITEMS_KEYS.Profile,
    url: MENU_ROUTES.profile,
    icon: <ProfileIcon />,
  },
  {
    title: TAB_ITEMS_KEYS.Users,
    url: MENU_ROUTES.users,
    icon: <UsersIcon />,
  },
  {
    title: TAB_ITEMS_KEYS.Brands,
    url: MENU_ROUTES.brands,
    icon: <TagFilled />,
    hidden: !permissions.READ_BRAND,
  },
  {
    title: TAB_ITEMS_KEYS.PaymentMethods,
    url: MENU_ROUTES.paymentMethods,
    icon: <PaymentMethods />,
    hidden: !permissions.READ_PAYMENTS,
  },
  {
    title: TAB_ITEMS_KEYS.Billing,
    url: MENU_ROUTES.billing,
    icon: <Billing />,
    hidden: !permissions.READ_AD_ACCOUNT || !permissions.READ_PAYMENTS,
  },
  {
    title: TAB_ITEMS_KEYS.Notifications,
    url: MENU_ROUTES.notifications,
    icon: <Notifications />,
    hidden: !permissions.UPDATE_NOTIFICATION_SETTINGS,
  },
];

export const ACCOUNT = 'Account';
export const ACCOUNT_MANAGEMENT = 'Account Management';
export const SWITCH_ORGANIZATION = 'Switch Organization';
export const SIGN_OUT = 'Sign Out';

export const USER_ROLE_FILTER = [
  { value: 'ORG_ADMIN', label: 'Admin' },
  { value: 'MEMBER', label: 'Member' },
];

export const CARD_LOGO: { readonly [key: string]: JSX.Element } = {
  Discover: <Discover data-testid="logoDiscover" />,
  Mastercard: <MasterCard data-testid="logoMasterCard" />,
  'American Express': <AmericanExpress data-testid="logoAmericanExpress" />,
  Visa: <Visa data-testid="logoVisa" />,
};

export const ACCOUNT_ROLES_TOOLTIPS: {
  readonly [key: string]:
    | {
        title: string;
        text: string;
      }
    | undefined;
} = {
  AD_ACCOUNT_ANALYST: {
    title: 'Analyst',
    text: 'Ad Account Analysts can view campaigns and Ads and manage reports in assigned Ad Accounts. They can also view organization information, organization Admin users, and Ad Accounts and members and billing and payment information in assigned Ad Accounts.',
  },
  BUYER: {
    title: 'Buyer',
    text: 'Ad Account Buyers can manage campaigns, Ads, and reports in assigned Ad Accounts. They can also view organization information, organization Admin users, and Ad Accounts and members and billing and payment information in assigned Ad Accounts.',
  },
  AD_ACCOUNT_ADMIN: {
    title: 'Ad Account Admin',
    text: 'Ad Account Admins can invite users and manage Ad Accounts and members in assigned Ad Accounts. They can manage campaigns, Ads, and reports in assigned Ad Accounts. They can also view organization information, organization Admin users, and Ad Account Admin users and billing and payment information in assigned Ad Accounts.',
  },
  ADMIN: {
    title: 'Admin',
    text: 'Ad Account Admins can invite users and manage Ad Accounts and members in assigned Ad Accounts. They can manage campaigns, Ads, and reports in assigned Ad Accounts. They can also view organization information, organization Admin users, and Ad Account Admin users and billing and payment information in assigned Ad Accounts.',
  },
};
